(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[194],{

/***/ "JxsF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/widgets/happy-to-care/HappyToCare.jsx
var HappyToCare = __webpack_require__("N+pC");

// CONCATENATED MODULE: ./src/client/components/lines/happy-to-care-line/HappyToCareLine.jsx

var __jsx = react_default.a.createElement;




var HappyToCareLine_HappyToCareLine = function HappyToCareLine(_ref) {
  var _businessSocialRespon;

  var id = _ref.id,
      seeMoreLink = _ref.seeMoreLink,
      businessSocialResponsibility = _ref.businessSocialResponsibility;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  if (!(businessSocialResponsibility === null || businessSocialResponsibility === void 0 ? void 0 : (_businessSocialRespon = businessSocialResponsibility.items) === null || _businessSocialRespon === void 0 ? void 0 : _businessSocialRespon.length)) {
    return null;
  }

  return __jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    "data-testid": "happyToCare",
    id: id,
    isWide: !isTablet
  }, __jsx(HappyToCare["a" /* HappyToCare */], Object(esm_extends["a" /* default */])({}, businessSocialResponsibility, {
    className: "mt-80 md:mt-0",
    url: seeMoreLink
  })));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/happy-to-care/descriptor.js

/* harmony default export */ var descriptor = __webpack_exports__["default"] = (HappyToCareLine_HappyToCareLine);

/***/ })

}]);